import { useEffect, useRef } from 'react';

// Achado de acessibilidade (auditoria retroativa de Skills, specs/skills/plan.md,
// 2026-09-15): nenhum modal/popup da feature de Skills respondia à tecla Esc, só clique no
// overlay ou botão explícito - inconsistente com o único precedente do projeto
// (Sabesp/DocumentViewer/index.js, useEffect + listener no document).
//
// Pilha compartilhada em vez de um listener por componente: com popups empilhados (ex.: o
// diálogo de conflito de nome sobre o Gerenciador de Skills), um listener por modal faria o
// Esc fechar TODOS de uma vez (todos escutam o mesmo document). A pilha garante que só o
// modal mais recente (o de cima) fecha a cada Esc.
const pilhaDeFechamento = [];

if (typeof document !== 'undefined') {
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || pilhaDeFechamento.length === 0) {
      return;
    }
    const fecharTopo = pilhaDeFechamento[pilhaDeFechamento.length - 1];
    fecharTopo();
  });
}

// `onClose` deve ser estável (useCallback) ou aceitar ser recriado a cada render - o hook
// sempre usa a versão mais recente (guardada numa ref), então recriar `onClose` não causa
// remoção/reinserção desnecessária na pilha.
function useEscapeToClose(onClose, isActive = true) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isActive) {
      return undefined;
    }
    const fechar = () => onCloseRef.current();
    pilhaDeFechamento.push(fechar);
    return () => {
      const idx = pilhaDeFechamento.lastIndexOf(fechar);
      if (idx !== -1) {
        pilhaDeFechamento.splice(idx, 1);
      }
    };
  }, [isActive]);
}

export default useEscapeToClose;
